import { X } from "lucide-react";

export default function QuoteDetailsModal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-[100] bg-black/35 p-4 backdrop-blur-sm">
      <div className="mx-auto flex h-full max-w-[1600px] flex-col overflow-hidden rounded-sm border border-[#edebe9] bg-white shadow-2xl">
        <div className="flex h-11 shrink-0 items-center justify-between border-b border-[#edebe9] bg-[#faf9f8] px-3">
          <div className="text-sm font-semibold text-[#201f1e]">
            Quote details
          </div>

          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded-sm text-[#605e5c] hover:bg-[#f3f2f1] hover:text-[#201f1e]"
            title="Close quote"
          >
            <X size={18} />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
      </div>
    </div>
  );
}